import "bootstrap/dist/css/bootstrap.min.css";
import fotografo from '../assets/Investigaciones/c97bcbad-35ae-42e8-a1b9-07a82122434f.jpeg'
import cuatro from '../assets/Investigaciones/d0adf3f4-8675-4434-878e-33c386870a9a.jpeg'
import investigador from '../assets/Investigaciones/investigador privado argentina.jpeg'
import investigador2 from '../assets/Investigaciones/investigacion de personas.jpeg'


const ImageCarousel = () => {
  const images = [
    { id: 1, src: {fotografo}, alt: "Imagen 1" },
    { id: 2, src: {cuatro}, alt:"Imagen 3" },
    { id: 3, src: {investigador}, alt:"Investigador privado argentina" },
    { id: 4, src: {investigador2}, alt:"Investigacion de personas" }
  ];
  
  return (    
      <div className="slider-c">
        <div className="slide-track-inv">
            <div className="slide-c">
                <img alt="" className="img-c" src={fotografo}/>
            </div>
            <div className="slide-c">
                <img alt="" className="img-c" src={cuatro}/>
            </div>
            <div className="slide-c">
                <img alt="" className="img-c" src={investigador}/>
            </div>
            <div className="slide-c">
                <img alt="" className="img-c" src={investigador2}/>
            </div>


            <div className="slide-c">
                <img alt="" className="img-c" src={fotografo}/>
            </div>
            <div className="slide-c">
                <img alt="" className="img-c" src={cuatro}/>
            </div>
            <div className="slide-c">
                <img alt="" className="img-c" src={investigador}/>
            </div>
            <div className="slide-c">
                <img alt="" className="img-c" src={investigador2}/>
            </div>
        </div>
      </div>

  );
}

export default ImageCarousel;